import React from 'react';
import PropTypes from 'prop-types';

export default function SingleDatePickerPlaceholder(props) {
    return (
        <div className="SingleDatePicker SingleDatePicker_1">
            <div>
                <div className="SingleDatePickerInput SingleDatePickerInput_1">
                    <div className="DateInput DateInput_1">
                        <input
                            type="text"
                            className="DateInput_input DateInput_input_1"
                            aria-label={props.placeholder}
                            id={props.id}
                            name={props.id}
                            value={props.value || ''}
                            placeholder={props.placeholder}
                            autoComplete="off"
                            readOnly
                            aria-describedby="DateInput__screen-reader-message-pickupDate"
                        />
                        <p
                            className="DateInput_screenReaderMessage DateInput_screenReaderMessage_1"
                            id="DateInput__screen-reader-message-pickupDate">
                            Trykk på ned-tasten for å endre kalenderen og velge en dato. Trykk på spørsmålstegn-tasten for å se flere
                            snarveier for endring av dato.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

SingleDatePickerPlaceholder.propTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string,
};
